import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

export type LocalIsoFormat = 'date' | 'datetime' | 'relative';

@Pipe({
    name: 'localIso',
    pure: true,
    standalone: false
})
export class LocalIsoPipe implements PipeTransform {
  transform(value: string | Date, format: LocalIsoFormat = 'datetime'): string {
    // if no date value, return never
    if (!value) return 'Never';

    const date = new Date(value);
    // check for invalid date
    if (Number.isNaN(date.getTime())) return null;

    // convert to Luxon DateTime
    const dt = DateTime.fromJSDate(date);

    // if only date is needed
    if (format === 'date') {
      return dt.toISODate();
    }

    // if relative time is needed
    if (format === 'relative') {
      const currentDate = DateTime.local();
      const seconds = Math.floor(currentDate.diff(dt, 'seconds').seconds);

      if (seconds < 29) return 'Just now';

      const intervals: Record<string, number> = {
        year: 31536000,
        month: 2592000,
        week: 604800,
        day: 86400,
        hour: 3600,
        minute: 60,
        second: 1
      };

      for (const i in intervals) {
        const counter = Math.floor(seconds / intervals[i]);
        if (counter > 0) {
          return counter === 1 ? `${counter} ${i} ago` : `${counter} ${i}s ago`;
        }
      }

      return dt.toISO();
    }

    // default to local datetime format like "Feb/04/2026 15:36:47"
    return dt.toFormat('LLL/dd/yyyy HH:mm:ss');
  }
}
